import React from 'react'
import './Credit.scss';
import CreditImage from '../../../../assets/CreditImage.png';

export default function Credit({ onHowWorkClick, onEarnClick, onSubClick }) {
  return (
    <div className='credit-container'>
      <div className='left-section'>
        <h1>A flexible M Coin based model designed to give you easy access to all premium tools</h1>
        <p>
          M Coins are MyPDF.club’s internal credits, used to access premium features across the platform. Instead of being tied to fixed plans, you get the freedom to use tools only when you need them—either by earning coins or subscribing for convenience.
        </p>
        <div className='links-container'>
          <p onClick={onHowWorkClick}>How M Coins Works?</p>
          <p onClick={onEarnClick}>How to earn M Coins?</p>
          <p onClick={onSubClick}>Subscription Plans</p>
        </div>
      </div>
      <div className='right-section'>
        <img src={CreditImage} alt="credit detail" />
      </div>
    </div>
  )
}
